import { clientFetch } from '@nackle/salesmaker-client-fetch';
import auth from 'app/auth';
import * as get from 'lodash/get';

const clientFetchWithCatch = opts =>
    clientFetch( opts ).catch( error => {
        const authErrors = [ 401, 403 ];
        const code = error.responseCode;
        const responseContentReason = get( error, 'responseContent.reason', false );
        if ( authErrors.includes( code ) ) {
            auth.signOut();
        } else if ( responseContentReason ) {
            alert( responseContentReason );
        } else {
            alert( 'The application has received an error. Please contact technical support.' );
        }
    } );

export { clientFetchWithCatch as clientFetch };
